import React from 'react'
import newDayCarousel from '../../../images/new_day_carousel.png'
import oldPerformanceView from '../../../images/old_performance_view.png'
import standardPoster from '../../../images/standard_poster.png'
import hoveranimationPoster from '../../../images/hoveranimation_poster.png'
import fskPoster from '../../../images/fsk_poster.png'
import coloredAttributes from '../../../images/colored_language_attributes.png'
import standardAttributes from '../../../images/no_colored_language_attributes.png'
import movieSharing from '../../../images/sharing.png'

const UpdateItem21Feb2023 = ({date, lastUpdate, onClick, activeUpdateText, id}) => {
    const additionalClass = lastUpdate ? 'update-text-open' : activeUpdateText === id ? 'update-text-open' : 'update-text-close' 
    return (
        <div className={"" + additionalClass}>
            {onClick ? (<p onClick={()=>onClick(additionalClass, id)} className="update-title cursor-pointer title-large-color gap-10">{date}</p>)
            :
            (<p className="title-large-color gap-10">{date}</p>)}
            <div className="update-text-content">
                <p className="text-regular-color text-regular-uppercase">
                    NEUES FEATURE / NEW FEATURE
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                        Wir haben ein paar neue Einstellungsmöglichkeiten entwickelt. 
                        Falls vom neuen Standard abweichende Einstellungen gewünscht sind, schicken Sie uns gerne eine Mail an: <a href="mailto:support@pmkino.com">support@pmkino.com</a><br/>
                        <span className='grey'>We have developed a few new settings options. 
                        If settings different from the new standard are desired, feel free to send us a mail at: <a href="mailto:support@pmkino.com">support@pmkino.com</a><br/></span>
                    </p>
                    <p className="text-regular orange uppercase gap-10">
                        Neue Mobile Vorstellungsansicht<br/>
                        <span className='grey'>New Mobile Performance View</span>
                    </p>
                    <div className='flex-container gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                                Neuer Standard:<br/>
                                <span className='grey'>New Standard:</span>
                            </p>
                            <img width="200px" src={newDayCarousel}/>
                        </div>
                        <div>
                            <p className="text-regular gap-10">
                                Alte Ansicht:<br/>
                                <span className='grey'>Old Version: </span>
                            </p>
                            <img width="200px" src={oldPerformanceView}/>
                        </div>
                    </div>
                    <p className="text-regular uppercase orange gap-10">
                        Neue Posterhoveranimation<br/>
                        <span className='grey'>New poster hover animation</span>
                    </p>
                    <div className='grid-container row gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                                Standard:<br/>
                                <span className='grey'>Standard:</span>
                            </p>
                            <img width="350px" src={standardPoster}/>
                        </div>
                        <div>
                            <p className="text-regular gap-10">
                                FSK Visualisierung (FSK 16 und 18):<br/>
                                <span className='grey'>FSK Visualization (FSK 16 and 18):</span>
                            </p>
                            <img width="350px" src={fskPoster}/>
                        </div>
                        <div>
                            <p className="text-regular gap-10">
                                Neue Hoveranimation:<br/>
                                <span className='grey'>New Hoveranimation:</span>
                            </p>
                            <img width="350px" src={hoveranimationPoster}/>
                        </div>
                    </div>
                    <p className="text-regular orange uppercase gap-10">
                        Anzeige der Attribute<br/>
                        <span className='grey'>Display of Attributes</span>
                    </p>
                    <div className='grid-container row gap-20'>
                        <div>
                            <p className="text-regular gap-10">
                                Neuer Standard:<br/>
                                <span className='grey'>New Standard:</span>
                            </p>
                            <img width="600px" src={coloredAttributes}/>
                        </div>
                        <div>
                            <p className="text-regular gap-10">
                                Alte Ansicht:<br/>
                                <span className='grey'>Old Version: </span>
                            </p>
                            <img width="600px" src={standardAttributes}/>
                        </div>
                    </div>
                    <p className="text-regular gap-10">
                        Den Filmen wurde eine Schaltfläche zum Teilen hinzugefügt.<br/>
                        <span className='grey'>A sharing button has been added to the movies.</span>
                    </p>
                    <img className='gap-20' width="600px" src={movieSharing}/>
                    <p className="text-regular gap-10">
                    Die Logik für den Login hat sich verbessert. Es ist ein Loadingscreen eingebaut worden. Man wird nun automtaisch abgemeldet, wenn die Authentifizierung abgelaufen ist.<br/>
                        <span className='grey'>The logic for the login has improved. A loading screen has been added. You are now automatically logged out when the authentication has expired.</span>
                    </p>
                    <p className="text-regular gap-10">
                    Sämtliche Popups haben ein Polishing erhalten, sodass diese nun einheitlich gestyled sind und identisch funktionieren. Der Hintergrund kann jetzt auch zum Schließen des Popups verwendet werden.<br/>
                        <span className='grey'>All popups have received a polishing, so that they are now uniformly styled and work identically. The background can now be used to close the popup.</span>
                    </p>
                    <p className="text-regular gap-10">
                    Für Matomo ist eine Erweiterung der Datenerhebung programmiert worden. Falls Interesse besteht, senden Sie uns hierzu gerne eine Mail an <a href="mailto:esm@planetmutlu.com">esm@planetmutlu.com</a>.<br/>
                        <span className='grey'>An extension of the data collection has been programmed for Matomo. If you are interested, please send us a mail to <a href="mailto:esm@planetmutlu.com">esm@planetmutlu.com</a>.</span>
                    </p>
                </div>

                <p className="text-regular-color text-regular-uppercase">
                    BUGFIX
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                        Das Cookiebanner war auf einigen Handybildschirmen zu groß und wurde angepasst. <br/>
                        <span className='grey'>The Cookiebanner was too big on some mobile screens and was adjusted.</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default UpdateItem21Feb2023
